import { render, staticRenderFns } from "./AdminStandards.vue?vue&type=template&id=75d36660"
import script from "./AdminStandards.vue?vue&type=script&lang=js"
export * from "./AdminStandards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports